import { Col, Row, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { dateCommon } from "../../helpers/common";

const PrintPage = styled.div`
  @media print {
    @page {
      size: landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div { font-family: 'Times New Roman', Times, serif !important; }
    label { font-family: 'Times New Roman', Times, serif !important; }
  }
`;

const ALL_COLUMNS = [
    { key: 'ma',             label: 'Mã nhân viên' },
    { key: 'hoTen',          label: 'Tên nhân viên' },
    { key: 'tenChucVu',      label: 'Chức vụ' },
    { key: 'tenDonVi',       label: 'Phòng ban' },
    { key: 'email',          label: 'Email' },
    { key: 'dienThoai',      label: 'Số điện thoại' },
    { key: 'gioiTinh',       label: 'Giới tính' },
    { key: 'ngaySinh',       label: 'Ngày sinh' },
    { key: 'ngayKetNap',     label: 'Ngày kết nạp Đảng' },
    { key: 'ngayChinhThuc',  label: 'Ngày chính thức' },
    { key: 'ngayVaoLam',     label: 'Ngày vào làm' },
    { key: 'tenTrinhDoLLCT', label: 'Trình độ LLCT' },
    { key: 'tenHocHam',      label: 'Trình độ học vấn' },
    { key: 'queQuan',        label: 'Quê quán' },
    { key: 'noiSinh',        label: 'Nơi sinh' },
    { key: 'diaChiNoiO',     label: 'Địa chỉ nơi ở' },
];

const DATE_KEYS = ['ngaySinh', 'ngayKetNap', 'ngayChinhThuc', 'ngayVaoLam'];

const InDanhSachNhanVien = ({
    dataSource,
    selectedColumns,
}: {
    dataSource: any[];
    selectedColumns: string[];
}) => {
    const user = useSelector((state: any) => state.auth.currentUser);
    const now = new Date();

    const visibleColumns = ALL_COLUMNS.filter(col => selectedColumns.includes(col.key));

    const columns: ColumnsType<any> = [
        {
            title: 'STT',
            key: 'STT',
            align: 'center',
            width: 50,
            render: (_: any, __: any, index: number) => index + 1,
        },
        ...visibleColumns.map(col => ({
            title: col.label,
            key: col.key,
            render: (_: any, record: any) => {
                if (col.key === 'gioiTinh') {
                    return record.gioiTinh === 0 ? 'Nam' : 'Nữ';
                }
                if (DATE_KEYS.includes(col.key)) {
                    return dateCommon.formatDate(record[col.key]);
                }
                if (col.key === 'diaChiNoiO') {
                    return [record.soNhaNoiO, record.tenPhuongXaNoiO, record.tenTinhThanhNoiO]
                        .filter(Boolean).join(', ');
                }
                return record[col.key] ?? '';
            },
        })),
    ];

    return (
        <PrintPage>
            <div style={{ backgroundColor: 'white', padding: '10px' }}>
                <div className="text-center pt-2">
                    <Row gutter={8}>
                        <Col span={12}>
                            <div style={{ fontFamily: 'Times New Roman' }}>
                                ỦY BAN NHÂN DÂN THÀNH PHỐ<br />
                                <label>
                                    <span style={{ fontFamily: 'Times New Roman' }}>QUỸ ĐẦU TƯ PHÁT TRIỂN</span>
                                    <hr style={{ borderTop: '1px solid', width: '60%', marginLeft: '12mm', marginTop: '1px', marginBottom: '2px' }} />
                                </label>
                            </div>
                        </Col>
                        <Col span={12}>
                            <label style={{ fontFamily: 'Times New Roman' }}>
                                CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM<br />
                                <span>Độc lập - Tự do - Hạnh phúc</span>
                                <hr style={{ borderTop: '1px solid', width: '50%', marginLeft: '18mm', marginTop: '1px', marginBottom: '2px' }} />
                            </label>
                        </Col>
                        <Col span={24}>
                            <label style={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 'bold' }}>
                                DANH SÁCH NHÂN SỰ
                            </label>
                        </Col>
                    </Row>
                </div>

                <Row style={{ marginTop: '10px' }}>
                    <Col span={24}>
                        <Table
                            dataSource={dataSource.map((item, index) => ({ ...item, key: item.id ?? index }))}
                            columns={columns}
                            pagination={false}
                            size="small"
                            locale={{ emptyText: 'Không có dữ liệu' }}
                            bordered
                        />
                    </Col>
                </Row>

                <div style={{ marginTop: '25px' }}>
                    <Row gutter={8} className="text-center">
                        <Col span={8} />
                        <Col span={8} />
                        <Col span={8}>
                            <div style={{ fontFamily: 'Times New Roman', fontStyle: 'italic' }}>
                                Đà Nẵng, ngày {('0' + now.getDate()).slice(-2)} tháng {('0' + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={8} className="text-center" style={{ marginTop: '8px' }}>
                        <Col span={8}><label style={{ fontFamily: 'Times New Roman' }}>Người lập</label></Col>
                        <Col span={8} />
                        <Col span={8}><label style={{ fontFamily: 'Times New Roman' }}>Giám đốc</label></Col>
                    </Row>
                    <Row gutter={8} className="text-center" style={{ paddingTop: '80px' }}>
                        <Col span={8}><label style={{ fontFamily: 'Times New Roman' }}>{user?.hoTen}</label></Col>
                        <Col span={8} />
                        <Col span={8} />
                    </Row>
                </div>
            </div>
        </PrintPage>
    );
};

export default InDanhSachNhanVien;